<script>
import axios from 'axios'
import store from '@state/store'
import { httpServices } from '@utils/http-services'

export default {
  data() {
    return {
      loading: false,
      touched: false,
      unsubscribe: null,
      sessionLoading: false,
    }
  },
  methods: {
    initAppStream() {
      /* eslint-disable */
      this.touched = true
      const container = store.getters['appstream/selectedAppstream']
      const appId = container.bonfireId || ''
      axios
        .get(`${process.env.VUE_APP_KONSUL_APPSTREAM_URL}`, {
          params: {
            appId,
            userId: this.$auth.user.email.split('').slice(0, 30).join(''),
          },
        })
        .then(
          (res) => {
            const toolbarEnabled = []

            const toolbarDisabled = [
              AppStream.Embed.Elements.CLIPBOARD_BUTTON,
              AppStream.Embed.Elements.COPY_LOCAL_BUTTON,
              AppStream.Embed.Elements.PASTE_REMOTE_BUTTON,
            ]
            const toolbarConfig = container?.meta?.toolbar
              ? toolbarEnabled
              : toolbarDisabled
            const appstreamOptions = {
              sessionURL: res.data.StreamingURL,
              userInterfaceConfig: {
                [AppStream.Embed.Options.HIDDEN_ELEMENTS]: toolbarConfig,
              },
            }
            window.appstreamEmbed = new AppStream.Embed(
              'appstream-container',
              appstreamOptions
            )

            window.appstreamEmbed.addEventListener(
              AppStream.Embed.Events.SESSION_STATE_CHANGE,
              (e) => {
                if (e?.sessionStatus === 'Started') {
                  setTimeout(() => {
                    this.loading = false
                    store.commit('appstream/SET_LOADING', false)
                  }, 500)
                }
              }
            )

            window.appstreamEmbed.addEventListener(
              AppStream.Embed.Events.SESSION_ERROR,
              (e) => {
                if (e) {
                  setTimeout(() => {
                    this.loading = false
                    store.commit('appstream/SET_LOADING', false)
                  }, 500)
                }
              }
            )
          },
          (_err) => {
            this.loading = false
            this.touched = false
            store.commit('appstream/SET_LOADING', false)
          }
        )
        .then(() => {
          const then = container.meta.lastAccessed
          const now = new Date().getTime()
          const msBetweenDates = Math.abs(then - now)
          const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000)
          const uniqueUsers = []

          if (then) {
            if (hoursBetweenDates < 1) {
              container.meta.currentUsers.forEach((c) => {
                if (!uniqueUsers?.includes(c)) {
                  uniqueUsers.push(c)
                }
              })
              container.meta.currentUsers = uniqueUsers
            } else {
              container.meta.currentUsers = [this.$auth.user.email]
            }
          } else {
            container.meta.currentUsers = [this.$auth.user.email]
          }

          container.meta.lastAccessed = now

          httpServices.updateContainer(container)
        })
    },
    watcher() {
      this.unsubscribe = store.subscribe((mutation, _state) => {
        if (mutation.type === 'appstream/SET_APPSTREAM') {
          this.touched = true
          // blow up previous app stream container
          this.loading = true
          store.commit('appstream/SET_LOADING', true)
          window.document.getElementById('appstream-container').innerHTML = ''
          // init app stream instance
          this.initAppStream()
        }
      })
    },
  },
  mounted() {
    this.watcher()
  },
  beforeDestroy() {
    this.unsubscribe()
  },
}
</script>

<template>
  <div style="height: 100%">
    <div id="appstream-container" v-bind:class="{ active: touched }"></div>
    <div class="nostream" v-if="!touched">
      <div>
        <img
          src="https://vanished-fe.s3.us-east-2.amazonaws.com/mantle-2-sq-b.png"
          alt="mantle"
        />
        <p class="ant-card-meta-description"
          >Select an image from the list above.</p
        >
      </div>
    </div>
    <div v-if="loading" class="loaderappstream">
      <section class="container">
        <video
          class="fullscreen"
          src="https://vanished-fe.s3.us-east-2.amazonaws.com/wave-2.mp4"
          playsinline
          autoplay
          muted
          loop
        >
        </video>

        <div class="content">
          <div id="load-content">
            <img
              src="https://vanished-fe.s3.us-east-2.amazonaws.com/mantle-w-2.png"
              alt="mantle"
            />
            <h5
              >preparing virtual machine...connecting to hardware in the
              field...</h5
            >
            <a-icon type="loading" style="font-size: 36px; color: #fff" spin />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<style lang="scss">
@import '@design';

.nostream {
  display: flex;
  align-content: center;
  justify-content: center;
  height: 100%;
  min-height: calc(100vh - 12rem);
  text-align: center;

  img {
    width: 100px;
    margin-bottom: 24px;
    opacity: 0.1;
  }

  > div {
    align-self: center;
  }
}

.loaderappstream {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 2rem;
  text-align: center;
  background: white;

  video.fullscreen {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 0;
    width: 100%;
    height: 100%;
    background: url('https://vanished-fe.s3.us-east-2.amazonaws.com/wave-2.gif')
      no-repeat center;
    background-size: cover;
    transition: 0.2s ease-in-out;
    transform: translate(-50%, -50%);
    object-fit: cover;

    &::-webkit-media-controls {
      display: none !important;
    }
  }

  .container {
    position: relative;
    display: grid;
    width: 70vw;
    height: 70vh;
    margin: 0 auto;
    place-items: center;
  }

  .content {
    z-index: 1;

    #load-content {
      text-align: center;
      img {
        display: block;
        width: 300px;
        margin: 0 auto 2rem auto;
      }
      h5 {
        margin-bottom: 2rem;
        color: white;
      }
    }
  }
}
</style>
